// extracted by mini-css-extract-plugin
module.exports = {"metric":"benchmark_metric__i_Mkj","articleCard":"benchmark_articleCard__ZIN5E","articleBody":"benchmark_articleBody__K0Bey"};